<template>
  <div :class="drawerClass" @mouseenter="drawer = true" @mouseleave="drawer = false">
    <v-btn text class="drawer-open-button" @click.prevent.stop="drawer = !drawer">
      <v-icon :color="colorHex">fas {{buttonIcon}}</v-icon>
    </v-btn>
    <v-list>
      <v-list-item
        v-for="pair in stereoPairArray"
        :class="tileClass(pair.image1)"
        :key="pair.image1.imgKey"
        @click="changeSelect(pair.image1, pair.image2, pair.index)">
        <v-list-item-content>
          <stereo-pair-thumbnail         
            :image1=pair.image1
            :image2=pair.image2 />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import stereoPairThumbnail from "./StereoPairThumbnail";
import { mapGetters } from "vuex";
export default {
  name: "stereoImageDrawer",
  props: {
    pairArray: Array
  },
  components: { stereoPairThumbnail },
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    selectImage(selectedImage) {
      if (selectedImage.imgKey !== this.currentBrowserImage.imgKey)
        this.$store.commit("selectImage", selectedImage);
    },
    tileClass(selectedImage) {
      let selected =
        this.currentBrowserImage &&
        this.currentBrowserImage.imgKey === selectedImage.imgKey;
      return (selected ? "selected-image " : "") + "image-tile " + this.colorClass;
    },
    changeSelect(image1, image2, index) {
      this.$store.commit("setStereoPair", {image1: image1, image2: image2, index: index});
    }
  },
  computed: {
    ...mapGetters(["stereoContext", "currentBrowserImage"]),
    drawerClass() {
      return "image-drawer-wrapper" + (this.drawer ? "" : " closed-drawer");
    },
    buttonIcon() {
      return this.drawer ? "fa-caret-left" : "fa-caret-right";
    },
    stereoPairArray() {
      if (this.pairArray)
        return this.pairArray;
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.image-drawer-wrapper ::v-deep {
  background-color: #424242;
  position: absolute;
  left: 0;
  top: 72px;
  bottom: 0;
  width: 250px;
  transition: 0.25s;
  z-index: 50;

  .drawer-open-button {
    background-color: $color-dark-grey;
    color: $color-blue;
    position: absolute;
    left: 250px;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    padding: 0;
    min-width: 0;
    height: 80px;
    margin: 0;
  }

  .v-list {
    overflow-y: auto;
    max-height: 100%;
  }

  .image-tile .v-list__tile {
    height: auto;
  }
}

.image-drawer-wrapper.closed-drawer {
  left: -252px;

  .v-list {
    display: none;
  }
}
</style>
